import React, { useCallback, useEffect, useMemo } from "react";
import moment from "moment";

// import { useDispatch, useSelector } from "react-redux";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { CustomButton } from "../../../../../components/Button/Button";
import DownArrow from "../../../../../styles/svg/date-range.svg";
import CustomMenu from "../../../../../components/Menu";
import WorkflowDateRangeFilter from "./DateRangeFilter";
// import { setDateRange } from "../../../../redux/SearchSlice";

function DateRangeFilterButton() {
  const [openDateFilter, setOpenDateFilter] = React.useState(null);
  const isMobile = useResponsive("down", "md");
  const [Olddate, updateParams, removeSearchParam] = useCustomSearchParams("missingStatus");
  const openDateFilterMenu = Boolean(openDateFilter);
  const date = JSON.parse(Olddate);

  useEffect(() => {
    if (date) {
      const obj = {
        startDate: new Date(date.startDate),
        endDate: new Date(date.endDate),
        key: "selection",
      };
      // dispatch(setDateRange(obj));
    }
  }, []);

  const handleClick = useCallback((event) => {
    setOpenDateFilter(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setOpenDateFilter(null);
  }, []);

  const heading = useMemo(() => {
    return date
      ? `${moment(date.startDate).format("MM/DD/YYYY")} - ${moment(date.endDate).format("MM/DD/YYYY")}`
      : "Select Date Range";
  }, [date]);

  return (
    <div className={isMobile && "d-flex justify-content-end"}>
      <CustomButton
        variant="outlined"
        id="epics-board-dropdown"
        aria-haspopup="true"
        onClick={(event) =>handleClick(event)}
        endIcon={<img src={DownArrow} style={{ paddingRight: "2px" }} />}
        className="white-button report-date-range-filter-button"
      >
        <p className="date-range-filter-date">{heading}</p>
      </CustomButton>
      <CustomMenu
        id="user-menu"
        anchorEl={openDateFilter}
        open={openDateFilterMenu}
        onClose={handleClose}
        className="report-date-range-filter-menu"
      >
        <WorkflowDateRangeFilter onClose={handleClose} />
      </CustomMenu>
    </div>
  );
}
export default React.memo(DateRangeFilterButton);
